import getStyle from './getStyle';

const getHeightOfElement = function (ele) {
    return parseInt(getStyle(ele, 'height'));
};
export default getHeightOfElement;
